import { oauthSetupSteps } from "../oauthSetupSteps";
import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const paybin = defineConnector({
  identifier: "paybin",
  name: "Paybin",
  tagLine: "Authorized Paybin identity profiles",
  logo,
  tags: ["identity"],
  protocol: "http",
  defaultUrlPattern: () =>
    "https://idp\\.paybin\\.io/oauth/userinfo(?:\\?.*)?$",
  auth: oauthAuth,
  steps: oauthSetupSteps({
    identifier: "paybin",
    registrationUrl: "https://portfolio.paybin.io",
    scopes: ["openid", "profile"],
  }),
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://idp.paybin.io/oauth/authorize",
    tokenEndpoint: () => "https://idp.paybin.io/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => ["openid", "profile"],
    pkce: () => true,
    issuer: () => "https://idp.paybin.io",
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://idp.paybin.io/oauth/userinfo",
  },
});
